import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import IResource from '../../../app/_interfaces/IResource';

@Injectable({
  providedIn: 'root',
})
export class ResourcesService {
  constructor(private http: HttpClient) {}

  getAll(customers_id: number) {
    return this.http.get<IResource[]>(
      `${environment.api.protocol}://${environment.api.host}:${environment.api.port}/api/v1/customers/${customers_id}/resources`
    );
  }
}
